module.exports = __webpack_public_path__ + "img/icon_box_3_4.5ac68cf8.png";